/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
class AverageMarketBook extends Component {
   constructor(props) {
      super(props);
      this.state = {
         userTags: [],
         userBookList: [],
         marketId: "",
         currentUser: ""
      };
   }
   async componentDidMount() {
   }
   render() {
      let market = this.props.market
      let currRunnerId = this.props.currRunnerId
      let currRunner = market.runners.filter((runn) => {return (runn.id === currRunnerId)})
      return (
         <>
            <div id="userbook" className="modal fade show" style={{ display: "block", overflow: "auto" }} tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-modal="true">
               <div className="modal-dialog  modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">{!!currRunner ? currRunner[0].name : ""}</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.hideAvgBookPopup() }}>×</button>
                     </div>
                     <div className="modal-body ac-state">
                        <div className="row">
                           <div className="col-12">
                              <div className="table-responsive">
                                 <table id="example" className="table table-bordered table-sm font-14 nowrap">
                                    <thead>
                                       <tr>
                                          <th>Team</th>
                                          <th>Average</th>
                                       </tr>
                                    </thead>
                                    <tbody>
                                       {!!market.expo && market.expo !== {} && !!market.expo.runnersExposure && market.runners.map((bk_runn) => {
                                          let curr_runn_expo = market.expo.runnersExposure[(currRunnerId)]
                                          let bk_runn_expo = market.expo.runnersExposure[(bk_runn.id)]
                                          let average = (curr_runn_expo.sharingMe) / Math.abs(bk_runn_expo.sharingMe)
                                          return (<>
                                             {bk_runn.id !== currRunnerId &&
                                                <>
                                                   <tr>
                                                      <td> {bk_runn.name}</td>
                                                      <td>{bk_runn_expo.sharingMe !== 0 ? <span className={average >= 0 ? "text-success" : "text-danger"}>{parseFloat(Math.abs(average)).toFixed(2)} </span> : ""}</td>
                                                   </tr>
                                                </>}
                                          </>)
                                       })
                                       }
                                    </tbody>
                                 </table>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.hideAvgBookPopup() }}></div>
            </div>
         </>
      )
   }
}
function mapStateToProps(state) {
   return {
   };
}
function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(AverageMarketBook);